import { render, staticRenderFns } from "./AssignSampleTask.vue?vue&type=template&id=c06ae8ea&scoped=true"
import script from "./AssignSampleTask.vue?vue&type=script&lang=js"
export * from "./AssignSampleTask.vue?vue&type=script&lang=js"
import style0 from "./AssignSampleTask.vue?vue&type=style&index=0&id=c06ae8ea&prod&lang=scss&scoped=true"
import style1 from "./AssignSampleTask.vue?vue&type=style&index=1&id=c06ae8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ae8ea",
  null
  
)

export default component.exports